module.exports = "<div class=\"kng-inline-activity-loader\">\r\n  <div class=\"loading-spinner\"></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/layout/kingswell/kng-activity-indicator/kng-inline-activity-indicator.component.html
// module id = ../../../../../src/app/layout/kingswell/kng-activity-indicator/kng-inline-activity-indicator.component.html
// module chunks = main